/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import { Reservation } from '../../../../app/pages/reservation-management/reservation-list/core/_models'

type Props = {
  reservation: Reservation
}

const ReservationInfoCell: FC<Props> = ({reservation}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
       {/*<a href='#'>
        {reservation.image ? (
          <div className='symbol-label'>
            <img src={toAbsoluteUrl(`${reservation.image}`)} alt={reservation.image} className='w-100' />
          </div>
        ) : (
        <></>
        )}
      </a>
      */}
    </div>
    <div className='symbol symbol-circle symbol-50px overflow-hidden '>
    
    </div>
    <div className='d-flex flex-column'>
      <span className='text-gray-800  mb-1'>
        {reservation?.hotel?.name}
      </span>
    </div>
 
  </div>
)

export {ReservationInfoCell}
